module.exports = __webpack_public_path__ + "assets\\img\\css\\logo.svg?963ca284ae4e8ba3f489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/css/logo.svg
// module id = 214
// module chunks = 0